export default "__VITE_ASSET__Xe8mA2IO__"